module.exports = __webpack_public_path__ + "img/zscx.46764033.png";